import React, { useEffect, useState } from "react";
import useFetch from "../Hooks/useFetch";
import { missionsURL } from "../Hooks/URL";
import { useParams } from "react-router-dom";
import AddMission from "../Templates/Home/Missions/AddMission/AddMission";

function EditMissionPage() {
  const { id } = useParams();
  const url = `${missionsURL}/${id}`;

  const [mission, setMission] = useState(null);
  const { data, loading, error } = useFetch(url);

  useEffect(() => {
    if (!loading && !error && data) {
      setMission(data?.data);
    }
  }, [data, loading, error]);

  const category = mission?.category?.ageGroup;

  return (
    <AddMission
      category={category}
      loading={loading || !mission}
      mission={mission}
      isEdit={true}
    />
  );
}

export default EditMissionPage;
